import React, { useState } from 'react';
import styles from './EArchiveGroupListItemDeleteButton.module.scss';
import { Group, useDeleteGroupMutation } from '../../../../../graphql/graphql';
import DeleteIcon from '../../../../../Components/Icon/DeleteIcon';
import EArchiveGroupsListDeleteModal from '../EArchiveGroupsListDeleteModal/EArchiveGroupsListDeleteModal';
import useApiClient from '../../../../Base/Hooks/useApiClient';
import useNotification from '../../../../../Hooks/useNotification.hook';

interface Props {
	group: Group;
	onSubmit: () => void;
}

const EArchiveGroupListItemDeleteButton = ({ group, onSubmit }: Props) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [deleteGroup] = useDeleteGroupMutation();
	const { displayGQLError } = useApiClient();
	const { showNotificationSuccess } = useNotification();

	const handleCrossClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		setIsModalOpen(true);
	};

	const handleDeleteGroup = async () => {
		const response = await deleteGroup({
			where: { id: group.id },
		});

		if ('data' in response) {
			showNotificationSuccess({
				content: 'component.eArchive.groups.deleteGroupSuccess',
			});
			setIsModalOpen(false);
			onSubmit();
		} else {
			displayGQLError(response);
		}
	};

	return (
		<button className={styles.cross} onClick={handleCrossClick}>
			<DeleteIcon />
			{isModalOpen && (
				<EArchiveGroupsListDeleteModal
					isOpen
					onSubmit={handleDeleteGroup}
					onClose={() => setIsModalOpen(false)}
				/>
			)}
		</button>
	);
};

export default EArchiveGroupListItemDeleteButton;
